module.exports = __webpack_public_path__ + "static/media/KSM.6a00717e.svg";